// YouTube / Vimeo URL → embed-src detection. Pure, no DOM, no React —
// shared by the web app (renders the iframe) and the dev seeder (constructs
// `kind: 'video'` attachments on insert).
//
// Both providers expose privacy-friendly embed hosts (youtube-nocookie.com,
// player.vimeo.com); we always rewrite to those.
const YOUTUBE_REGEX = /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/;
const VIMEO_REGEX = /vimeo\.com\/(?:video\/)?(\d+)/;
const URL_REGEX = /\bhttps?:\/\/[^\s)]+/i;
const EMBED_BUILDERS = {
    youtube: (url) => {
        const m = YOUTUBE_REGEX.exec(url);
        const id = m?.[1];
        return id ? `https://www.youtube-nocookie.com/embed/${id}` : null;
    },
    vimeo: (url) => {
        const m = VIMEO_REGEX.exec(url);
        const id = m?.[1];
        return id ? `https://player.vimeo.com/video/${id}` : null;
    },
};
export function detectVideoEmbed(input) {
    const url = URL_REGEX.exec(input)?.[0] ?? input;
    for (const provider of ['youtube', 'vimeo']) {
        const embedSrc = EMBED_BUILDERS[provider](url);
        if (embedSrc !== null)
            return { provider, embedSrc };
    }
    return null;
}
export function buildEmbedSrc(provider, url) {
    return EMBED_BUILDERS[provider](url);
}
export function findFirstUrl(text) {
    return URL_REGEX.exec(text)?.[0] ?? null;
}
export const VIDEO_EMBED_IFRAME_ALLOW = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
//# sourceMappingURL=video-embed.js.map